import { default as MouseWheelZoom } from 'ol/interaction/MouseWheelZoom';
import { default as RBaseInteraction } from './RBaseInteraction';
/** Mouse wheel zoom */
class RMouseWheelZoom extends RBaseInteraction {
    createOL(props) {
        this.classProps = RMouseWheelZoom.classProps;
        return new MouseWheelZoom(Object.keys(props)
            .filter((p) => this.classProps.includes(p))
            .reduce((ac, p) => (Object.assign(Object.assign({}, ac), { [p]: props[p] })), {}));
    }
}
RMouseWheelZoom.classProps = [
    'condition',
    'maxDelta',
    'duration',
    'useAnchor',
    'constrainResolution'
];
export default RMouseWheelZoom;
//# sourceMappingURL=RMouseWheelZoom.js.map